import {AfterViewInit, Component, ViewChild} from '@angular/core';
import {HeroApplicationFrameComponent} from "lib-hero";
import {BooxMessageService} from "lib-boox";
import {HeroHostService} from "lib-hero";

@Component({
  selector: 'app-application-view',
  standalone: true,
  imports: [HeroApplicationFrameComponent],
  templateUrl: './application-view.component.html',
  styleUrl: './application-view.component.scss'
})
export class ApplicationViewComponent implements AfterViewInit {

  @ViewChild(HeroApplicationFrameComponent) appFrame: HeroApplicationFrameComponent | undefined;

  appName: string | null = null;

  constructor(
    private message: BooxMessageService,
    private app: HeroHostService
  ) {    //
    this.message.on$('app.run.reload').subscribe(() => {
      if (this.appFrame) this.appFrame.refreshFrameSrc();
    });

    this.message.on$('app.run.use').subscribe((message) => {
      console.log('app.run.use', message);
    });

    this.appName = this.app.get('guest.app.current').name;
    this.app.key$('guest.app.current').subscribe(({ name } : { name : string}) => {
      this.appName = name || null;
    });
  }

  ngAfterViewInit(): void {
    this.appFrame;
  }
}
